import React from "react";

const CloseButton = (props) => (
    <button
        {...props}
        type="button"
        className={`btn-close ${props.className}`}
    />
);

export default CloseButton;